// extracted by mini-css-extract-plugin
export default {"user":"Mla3","processing":"ci0F","cursorNotAllowed":"BSKe"};